var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container container--mobile" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("br"),
                  _vm._v(" "),
                  _c("Pagination", {
                    attrs: { numberOfDots: 4, numberOfVisitedDots: 1 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-wrapper margin-top-75" }, [
                    _c("h2", {
                      staticClass: "text-left text-primary-fh",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.optout.optoutHeader)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.data.optout.optoutText) }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-top-25" })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("h4", {
                    staticClass: "text-primary-fh left-header",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.optout.areyousureHeader)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-top-25" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-block",
                      on: {
                        click: function($event) {
                          return _vm.denyConsent()
                        }
                      }
                    },
                    [_vm._v("Ja")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("router-link", { attrs: { to: "/welcome" } }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary btn-lg btn-block"
                      },
                      [_vm._v("Nej")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("small", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.optout.disclaimerText)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2de4ef6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de4ef6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OptOut.vue
// module id = null
// module chunks = 